var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-body-lazy-loading",class:{ visible: _vm.visible }},[_c('img',{attrs:{"src":require("./img/lazy-data-loading.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }